// eslint-disable-next-line @typescript-eslint/no-explicit-any
const buildSearchParams = (param: Record<string, any>) => {
  const searchParams = new URLSearchParams();
  Object.entries(param).forEach(([key, value]) => {
    if (value !== undefined) {
      if (Array.isArray(value)) {
        value.forEach((value) => searchParams.append(key, value.toString()));
      } else {
        searchParams.append(key, value.toString());
      }
    }
  });

  return searchParams;
};

export default buildSearchParams;
